module.exports = __webpack_public_path__ + "VIPH9.png?301da9d834964a36587f55b27446ccdc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH9.png
// module id = 102
// module chunks = 0